import { useContext } from 'react';
import { CurrentDocumentContext } from '../providers/CurrentDocumentProvider';

/** Get the current document, useful for when content is rendered in a popup window,
 * which has a different document than the rest of the application */
export function useCurrentDocument(): Document {
  // Provider is not required since we have a useful default value
  return useContext(CurrentDocumentContext).currentDocument;
}

/** Get the current window, useful for when content is rendered in a popup window,
 * which has a different window than the rest of the application */
export function useCurrentWindow(): Window {
  // Provider is not required since we have a useful default value
  return useContext(CurrentDocumentContext).currentWindow;
}

export function useIsPopout(): boolean {
  const currentWindow = useCurrentWindow();
  return currentWindow !== window;
}
